import { render, staticRenderFns } from "./successRegister.vue?vue&type=template&id=46ee92f4&scoped=true&"
import script from "./successRegister.vue?vue&type=script&lang=js&"
export * from "./successRegister.vue?vue&type=script&lang=js&"
import style0 from "./successRegister.vue?vue&type=style&index=0&id=46ee92f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee92f4",
  null
  
)

export default component.exports